module.exports = __webpack_public_path__ + "static/media/Ultra R6.a901fe3f.mp4";